import { render, staticRenderFns } from "./Register-applicant-healthcare.vue?vue&type=template&id=18ce5856&scoped=true&"
import script from "./Register-applicant-healthcare.vue?vue&type=script&lang=js&"
export * from "./Register-applicant-healthcare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce5856",
  null
  
)

export default component.exports